import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ValidateService {

  constructor(private translate: TranslateService) { }

  validateRequiredFields(targetObject, arrayTests: Array<any>): any {
    let error: any = {};
    let isCanSubmit = true;
    for (const test of arrayTests) {
      error[test] = {};
      if (!targetObject.hasOwnProperty(test) || targetObject[test] + '' === '' || targetObject[test] === undefined
          || targetObject[test] === null || targetObject[test].toString() === '') {
        error[test].erc = '0';
        error[test].value = this.translate.instant('this_field_is_required');
        isCanSubmit = false;
      } else {
        error[test].erc = '1';
        error[test].value = '';
      }
    }
    return {submit: isCanSubmit, data: error};
  }
   isNormalInteger(targetObject, arrayTests: Array<any>) {
    const error: any = {};
    let isCanSubmit = true;
    for (const test of arrayTests) {
      error[test] = {};
      if (!targetObject.hasOwnProperty(test) || targetObject[test] + '' === '' || targetObject[test] === undefined 
          || targetObject[test] === null || targetObject[test].toString() === '') {
        error[test].erc = '0';
        error[test].value = this.translate.instant('this_field_is_required');
        isCanSubmit = false;
      } else {
        targetObject[test] = targetObject[test].trim();
        targetObject[test] = targetObject[test].replace(/^0+/, "") || "0";
        const n = Math.floor(Number(targetObject[test]));
        isCanSubmit = n !== Infinity && String(n) === targetObject[test] && n >= 0;
        if (!isCanSubmit) {
          error[test].erc = '0';
          error[test].value = this.translate.instant('enter a valid amount');
        } else {
          error[test].erc = '1';
          error[test].value = '';
        }
      }
    }
    return {submit: isCanSubmit, data: error};
}

  validateRequiredFieldsV2(targetObject, arrayTests: Array<any>): any {
    let error: any = {};
    let isCanSubmit = true;
    for (const test of arrayTests) {
      error[test] = {};
      if (!targetObject.hasOwnProperty(test) || targetObject[test] + '' === '' || targetObject[test] === undefined
          || targetObject[test] === null || targetObject[test].toString() === '') {
        error[test].erc = false;
        error[test].value = this.translate.instant('this_field_is_required');
        isCanSubmit = false;
      } else {
        error[test].erc = true;
        error[test].value = '';
      }
    }
    return {submit: isCanSubmit, data: error};
  }
}
